<template>
    <div class="gap-12 md:flex md:items-start print:flex-col">
        <div
            v-if="!store.mobileMode"
            class="sticky w-1/4 shrink-0 print:w-full"
            :style="{
                top: store.headerHeight + 1 + 'px',
            }"
        >
            <slot name="leftPanel" />
        </div>
        <UiSidebar
            v-if="store.mobileMode"
            :active="store.mobileLeftPanelOpen"
            has-manual-drawer-btn
            :direction="'from-bottom'"
        >
            <slot name="leftPanel" />
        </UiSidebar>
        <div class="grow">
            <slot />
        </div>
    </div>
</template>

<script lang="ts" setup>
const store = useMainStore()
</script>

<style></style>
